export enum ProcessTrackingTypeEnum {

  // Planning processes
  PlanningDispatch = "PlanningDispatch",
  PlanningImport = "PlanningImport",
  PlanningOptimizing = "PlanningOptimizing",
  CustomOrderProjectUpload = "CustomOrderProjectUpload",
  CustomRouteOrders = "CustomRouteOrders",

  // Visit Schedule processes
  SchedulingProjectDispatch = "SchedulingProjectDispatch",
  SchedulingProjectPublish = "SchedulingProjectPublish",

  // Visit Plan processes
  SchedulingProjectImport = "SchedulingProjectImport",
  SchedulingProjectSubmitChanges = "SchedulingProjectSubmitChanges",
  SchedulingProjectBulkDeleteCalls = "SchedulingProjectBulkDeleteCalls",
  SchedulingProjectBulkDeleteDeliveries = "SchedulingProjectBulkDeleteDeliveries",

  // Batch processes
  BatchProcess = "BatchProcess",

  // Projection Template processes
  BulkExpireCallTemplates = "BulkExpireCallTemplates",

  // Percentage
  ProcessTrackingPercentage = "ProcessTrackingPercentage"

}

